import gsap from "gsap";

import { writeSession } from "./barba";

let markLoaderDone!: () => void;
export const loaderDone = new Promise<void>(resolve => {
    markLoaderDone = resolve;
});

export function runLoader() {
    const loader = document.querySelector(".loader");
    if (!loader) {
        markLoaderDone();
        return Promise.resolve();
    }

    if (!document.documentElement.classList.contains("show-loader")) {
        loader.remove();
        markLoaderDone();
        return Promise.resolve();
    }

    return new Promise<void>(resolve => {
        let didFinish = false;

        const finish = () => {
            if (didFinish) return;
            didFinish = true;
            markLoaderDone();

            gsap.to(loader, {
                autoAlpha: 0,
                duration: 0.7,
                ease: "power2.out",
                onComplete: () => {
                    writeSession("hasSeenLoader", "1");
                    document.documentElement.classList.remove("show-loader");
                    loader.remove();
                    resolve();
                },
            });
        };

        window.addEventListener("logo:loader-sequence-complete", finish, { once: true });

        window.setTimeout(finish, 8000);
    });
}

export function skipLoader() {
    document.querySelector(".loader")?.remove();
    document.documentElement.classList.remove("show-loader");
    writeSession("hasSeenLoader", "1");
    markLoaderDone();
}
